/**
 * @flow
 * @relayHash 4880728c56d88ce16f91dad9d26ff74b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ReturnLineCondition = "DAMAGED" | "DEFECTIVE" | "GOOD" | "NEW" | "UNSALVAGEABLE";
export type ReturnLineDisposition = "QUARANTINE" | "REPAIR" | "RESTOCK" | "SCRAP";
export type ReturnOrderStatus = "AUTHORIZED" | "CLOSED" | "RECEIVED" | "REJECTED" | "REQUESTED";
export type ReturnReason = "CUSTOMER_CHANGED_MIND" | "DAMAGED" | "DEFECTIVE" | "NOT_AS_DESCRIBED" | "OTHER" | "WRONG_ITEM";
export type ReturnType = "CREDIT" | "REFUND" | "REPAIR" | "REPLACEMENT";
export type AddReturnOrderInput = {|
  orderId?: ?string,
  customerId: string,
  shipmentId?: ?string,
  returnType?: ?ReturnType,
  reason?: ?ReturnReason,
  notes?: ?string,
  customerNotes?: ?string,
  lines?: ?$ReadOnlyArray<ReturnOrderLineInput>,
|};
export type ReturnOrderLineInput = {|
  itemId: string,
  quantity: number,
  shipmentItemId?: ?string,
  condition?: ?ReturnLineCondition,
  disposition?: ?ReturnLineDisposition,
  notes?: ?string,
|};
export type AddReturnOrderMutationVariables = {|
  input: AddReturnOrderInput
|};
export type AddReturnOrderMutationResponse = {|
  +addReturnOrder: {|
    +returnOrderEdge: {|
      +node: {|
        +id: string,
        +returnNumber: string,
        +status: ReturnOrderStatus,
        +returnType: ?ReturnType,
        +reason: ?ReturnReason,
        +authorizedDate: ?any,
        +receivedDate: ?any,
        +notes: ?string,
        +customerNotes: ?string,
        +order: ?{|
          +id: string,
          +orderNumber: string,
        |},
        +customer: {|
          +id: string,
          +name: string,
        |},
        +shipment: ?{|
          +id: string,
          +shipmentNumber: string,
        |},
        +lines: {|
          +edges: ?$ReadOnlyArray<?{|
            +node: {|
              +id: string,
              +quantity: number,
              +receivedQuantity: number,
              +condition: ?ReturnLineCondition,
              +disposition: ?ReturnLineDisposition,
              +restocked: boolean,
              +notes: ?string,
              +item: {|
                +id: string,
                +name: string,
                +itemNumber: string,
              |},
            |}
          |}>
        |},
        +updatedAt: any,
        +createdAt: any,
      |}
    |}
  |}
|};
export type AddReturnOrderMutation = {|
  variables: AddReturnOrderMutationVariables,
  response: AddReturnOrderMutationResponse,
|};
*/


/*
mutation AddReturnOrderMutation(
  $input: AddReturnOrderInput!
) {
  addReturnOrder(input: $input) {
    returnOrderEdge {
      node {
        id
        returnNumber
        status
        returnType
        reason
        authorizedDate
        receivedDate
        notes
        customerNotes
        order {
          id
          orderNumber
        }
        customer {
          id
          name
        }
        shipment {
          id
          shipmentNumber
        }
        lines(first: 1000) {
          edges {
            node {
              id
              quantity
              receivedQuantity
              condition
              disposition
              restocked
              notes
              item {
                id
                name
                itemNumber
              }
            }
          }
        }
        updatedAt
        createdAt
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddReturnOrderInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "notes",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "addReturnOrder",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddReturnOrderPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "returnOrderEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "ReturnOrderEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "ReturnOrder",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "returnNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "status",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "returnType",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "reason",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "authorizedDate",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "receivedDate",
                "args": null,
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "customerNotes",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "order",
                "storageKey": null,
                "args": null,
                "concreteType": "Order",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "orderNumber",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "customer",
                "storageKey": null,
                "args": null,
                "concreteType": "Customer",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v3/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "shipment",
                "storageKey": null,
                "args": null,
                "concreteType": "Shipment",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "shipmentNumber",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "lines",
                "storageKey": "lines(first:1000)",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000
                  }
                ],
                "concreteType": "ReturnOrderLineConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ReturnOrderLineEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ReturnOrderLine",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "quantity",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "receivedQuantity",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "condition",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "disposition",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "restocked",
                            "args": null,
                            "storageKey": null
                          },
                          (v2/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              (v3/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "itemNumber",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "updatedAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AddReturnOrderMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v4/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AddReturnOrderMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v4/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "AddReturnOrderMutation",
    "id": null,
    "text": "mutation AddReturnOrderMutation(\n  $input: AddReturnOrderInput!\n) {\n  addReturnOrder(input: $input) {\n    returnOrderEdge {\n      node {\n        id\n        returnNumber\n        status\n        returnType\n        reason\n        authorizedDate\n        receivedDate\n        notes\n        customerNotes\n        order {\n          id\n          orderNumber\n        }\n        customer {\n          id\n          name\n        }\n        shipment {\n          id\n          shipmentNumber\n        }\n        lines(first: 1000) {\n          edges {\n            node {\n              id\n              quantity\n              receivedQuantity\n              condition\n              disposition\n              restocked\n              notes\n              item {\n                id\n                name\n                itemNumber\n              }\n            }\n          }\n        }\n        updatedAt\n        createdAt\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '23046669c5f3857458fbb6ce96f2bbf0';
module.exports = node;
